import {createContext, useContext, useEffect, useState} from "react";
import {useMap, useMapsLibrary} from "@vis.gl/react-google-maps";
import {useParams} from "react-router";

export const PointLayerContext = createContext(undefined);

const PointLayerProvider = ({children, setIsLoading, position, id}) => {
    const [icons, setIcons] = useState([])
    const [iconSelected, setIconSelected] = useState()
    const [points, setPoints] = useState([])

    const map = useMap();
    const markerLib = useMapsLibrary("marker");
    const coreLib = useMapsLibrary("core");

    return (
        <PointLayerContext.Provider value={{
            map, setIsLoading, icons, setIcons, iconSelected, setIconSelected, markerLib, coreLib, position,
            points, setPoints, id
        }}>
            {children}
        </PointLayerContext.Provider>
    );
}

export default PointLayerProvider;